import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { ThemeProvider } from 'styled-components';
// import theme from './theme';
// import media from './media';
import CurrentThemeProvider, {
  ThemeContext
} from './components/Layout/ThemeProviderToggle';

function ThemedApp() {
  const { currentTheme } = useContext(ThemeContext);
  return (
    <ThemeProvider theme={currentTheme.selectedTheme}>
      <App />
    </ThemeProvider>
  );
}

//Theme Provider for styled-components, reference props.theme within a styled component
//Adding styled-theme later.
ReactDOM.render(
  <CurrentThemeProvider>
    <ThemedApp />
  </CurrentThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
